import { atom } from 'recoil';

export const deviceTokenState = atom<string>({
  key: 'deviceTokenState',
  default: '',
});
